/* eslint-disable no-unused-vars */
<template>
  <div>
    <b-button :title="!this.editorMode ? 'Habilitar edição de Tela' : 'Desabilitar edição de Tela'"
      v-if="this.user.Permissions.editartelamonitoramento.allowed && isReady" id='btLock' size="sm"
      @click="ChangeEditMode()">
      <b-icon v-if="!this.editorMode" class="lockIcon" icon="lock" aria-hidden="true"></b-icon>
      <b-icon v-else icon="unlock" class="lockIcon" aria-hidden="true"></b-icon>
    </b-button>

    <span v-if="isReady">
      <grid-layout :cols="colsNumber" :layout.sync="layout" :row-height="layout2.gridMonitoringConfiguration.rowHeight"
        :is-draggable="editorMode" :is-resizable="layout2.gridMonitoringConfiguration.isResizable"
        :is-mirrored="layout2.gridMonitoringConfiguration.isMirrored"
        :vertical-compact="layout2.gridMonitoringConfiguration.verticalCompact"
        :margin="[layout2.gridMonitoringConfiguration.xMargin, layout2.gridMonitoringConfiguration.yMargin]"
        :use-css-transforms="layout2.gridMonitoringConfiguration.cssTransforms" :preventCollision="!editorMode"
        :responsive="layout2.gridMonitoringConfiguration.responsive" @click="click()">

        <grid-item v-for="item in layout" :static="item.staticCard" :key="item.i" :i="item.i" :x="item.x" :y="item.y"
          :w="item.w" :h="item.h" :minW="item.cardMinWidth" :minH="item.cardMinHeight">
          <MonitoringLayoutCard :item="item" :layout2="layout2" @sendSignalOpenModal="receive = $event" />
        </grid-item>
      </grid-layout>
    </span>

    <span v-else>
      <div class="waitTxt">{{ $t('aguardando-banco-de-dados') }}</div>
    </span>

    <b-modal id="UntratedOccurrences" size="xl" hide-footer>
      <div slot="modal-title" class="img-slot">
        <img style="width: 33px; height: 33px; margin-right: 10px" src="@/assets/circular138.png"
          alt="salvar_ocorrencia" />
        <label>{{ $t("untrated-occurrences") }}</label>
      </div>
      <ManageAllOccurrences :indicatorInfo="receive.item" :reloadOccFunct="loadGridMonitoring"
        :showActionResponsible="false"></ManageAllOccurrences>
    </b-modal>
  </div>
</template>

<script>

var task;
import VueGridLayout from 'vue-grid-layout';
import { urlMainAPI, defaultSuccess } from "@/global";
import { mapState } from "vuex";
import { rotationScreenMixin } from "../mixins/rotationScreenMixin"
import axios from "axios";
import ManageAllOccurrences from '../manageAllOccurrences/ManageAllOccurrences.vue';

import MonitoringLayoutCard from "./MonitoringLayoutCard.vue";

export default {
  mixins: [rotationScreenMixin],
  components: {
    MonitoringLayoutCard,
    ManageAllOccurrences,
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
  },
  computed: mapState(["msg", "user"]),
  watch: {
    $route(to) {
      this.unit = to.params.unit;
      clearTimeout(task);
      this.loadGridMonitoring();
    },

    receive() {
      this.$bvModal.show("UntratedOccurrences");
    }
  },
  data() {
    return {
      colsNumber: { 'lg': 7, 'md': 4, 'sm': 3, 'xs': 2, 'xxs': 1 },
      receive: {},
      editorMode: false,
      unit: this.$route.params.unit,
      canShowFooter: true,
      isReady: false,
      reliability: {
        pgdi: false,
        a: 0,
        b: 0,
        c: 0,
        daily: 0,
        gridOn: true
      },
      layout: [],
      layout2: {
        indicatorMonitoringGroup: {
          timestamp: "",
        },
        gridMonitoringConfiguration: {
          qtyColumns: 1,
          colNum: 8,
        },
      },
      gridId: null,
      minutesMonitoring: 0
    };
  },

  filters: {
    numberFormat(num) {

      if (num == "-9999" || num == "-9999,00") {
        return "0,00";
      }

      try {
        if (num.includes(",")) {
          num = num.replace(',', '.')
        }
        if (!isNaN(parseFloat(num))) {
          var numParsed = parseFloat(num);
          if (numParsed >= 100000 || numParsed <= -100000)
            return numParsed.toExponential(3)
          if (numParsed > 0 && numParsed < 1 || numParsed < 0 && numParsed > -1) {
            numParsed = numParsed.toFixed(4);
          } else {
            numParsed = numParsed.toFixed(2);
          }
          numParsed = numParsed.replace('.', ',').split(",")
          let v1 = numParsed[0]
          let v2 = numParsed[1]
          v1 = v1.split("").reverse()
          let i = 0
          var stop = 0
          if (v1.length / 3 >= 1 && v1.length % 3 != 0) {
            i = 1;
            stop = Math.trunc(v1.length / 3);
          }
          if (v1.length / 3 >= 1 && v1.length % 3 == 0) {
            i = 1;
            stop = Math.trunc(v1.length / 3) - 1
          }
          var pos = 3
          if (i >= 1) {
            for (i; i <= stop; i++) {
              v1.splice(pos, 0, ".");
              pos = pos + 4;
            }
          }
          numParsed = v1.reverse().join("") + ',' + v2
          if (numParsed.includes("-.")) {
            numParsed = numParsed.replace("-.", "-");
          }
          return numParsed
        }
        return "-"
      } catch (error) {
        return "-"
      }
    }
  },

  methods: {
    async loadGridMonitoring() {
      if (this.editorMode) { return }
      this.isReady = false;
      try {
        const url = `${urlMainAPI}/getindicatormonitoringlist/${this.unit}`;
        await axios
          .get(url)
          .then((res) => {
            if (this.canShowFooter) {
              this.layout = res.data.indicatorMonitoringGroup;
              this.layout2 = res.data;

              if (this.layout2.gridMonitoringConfiguration.qtyColumns != 0 && this.layout2.gridMonitoringConfiguration.qtyColumns < 20)
                this.colsNumber["lg"] = (this.layout2.gridMonitoringConfiguration.qtyColumns);

              this.gridId = res.data.gridMonitoringConfiguration.id;
              this.reliability.pgdi = res.data.gridMonitoringConfiguration.cardType == "PGDI" ? true : false;
              this.reliability.a = res.data.workshiftAReability;
              this.reliability.b = res.data.workshiftBReability;
              this.reliability.c = res.data.workshiftCReability;
              this.reliability.daily = res.data.dailyReability;
              this.reliability.gridOn = true;
              this.$store.commit("setMsg", `${this.unit.split("-")[0]} - ÚLTIMA ATUALIZAÇÃO: ${this.dateBR(this.layout2.timestamp)}`);
              this.$store.commit("setMsg2", this.reliability);

              // coloca no log o tempo atual
              console.log(">>-> Carregando a tela de monitoramento:", new Date().toLocaleString());
              task = setTimeout(() => {
                this.loadGridMonitoring();
              }, this.minutesMonitoring);
            }
          })
          .catch();
        this.isReady = true;
      } catch (error) {
        console.log("Erro na tela de monitoramento: " + error)
      }
    },

    async ChangeEditMode() {
      this.editorMode = !this.editorMode
      if (this.editorMode) {
        clearTimeout(task);
        this.$store.commit("setMsg", `MODO DE EDIÇÃO ATIVADO`);
        this.$store.commit("setMsg2", null);
      }
      if (!this.editorMode) {
        this.$store.commit("setMsg", `MODO DE EDIÇÃO DESATIVADO`);
        this.$store.commit("setMsg2", null);
        await this.SaveGridPosition()
      }
    },

    async SaveGridPosition() {
      let cardPositionList = []
      this.layout.forEach(x => {
        let obj = {};
        obj.indicatorId = x.id
        obj.productionUnitId = x.productionUnitId
        obj.system = x.system
        obj.gridId = this.gridId
        obj.cardXPosition = x.x
        obj.cardYPosition = x.y
        obj.cardWidth = x.w
        obj.cardHeight = x.h
        obj.cardMinWidth = x.cardMinWidth
        obj.cardMinHeight = x.cardMinHeight
        obj.cardStatic = x.cardStatic

        cardPositionList.push(obj)
      })

      const url = `${urlMainAPI}/savecardposition`;
      await axios
        .post(url, cardPositionList)
        .then(res => {
          defaultSuccess(res.data);
          this.loadGridMonitoring()
        })
        .catch(this.loadGridMonitoring)
    },

    dateBR(date) {
      let dateBr = Date.parse(date);
      dateBr = new Date(dateBr);
      dateBr = dateBr.toLocaleString("pt-BR");
      let info = dateBr.split(" ")
      dateBr = info[0];
      let time = info[1].substring(0, 5)
      if (dateBr == "Invalid" || date == "1900-01-01 00:00:00") {
        return "Aguardando dados do servidor ";
      } else {
        return dateBr = dateBr + " " + time;
      }
    },

    async getSystemConfiguration() {
      const url = `${urlMainAPI}/getsystemconfiguration`;
      await axios.get(url)
        .then(res => {
          this.minutesMonitoring = res.data.onlineMonitoringInterval * 60000;
        })
        .catch(console.log);
    },
  },

  async created() {
    clearTimeout(task);
    await this.getSystemConfiguration();
    this.loadGridMonitoring();
    this.startRotation();
  },

  beforeDestroy() {
    this.canShowFooter = false;
    this.$store.commit("setMsg", " ")
    this.$store.commit("setMsg2", { "reliability.pgdi": false, "reliability.a": 0, "reliability.b": 0, "reliability.c": 0, "reliability.daily": 0, "reliability.gridOn": false })
    clearTimeout(task);
    this.stopRotation();
  }
}
</script>

<style scoped>
* {
  font-weight: 100;
}

.img-slot {
  display: flex;
  align-content: center;
  justify-content: center;
}

.waitTxt {
  display: flex;
  justify-content: center;
  background: black;
  color: white;
  margin-bottom: 10px;
}

#btLock {
  position: absolute;
  top: 16px;
  left: 16px;
  background-color: transparent;
  border: none;
  z-index: 10;
  background: #fff;
  opacity: 0;
}


#btLock:hover {
  opacity: 1;
  transition-duration: 500ms;
}

.lockIcon {
  color: black;
}

@media only screen and (max-width: 1220px) {
  #btLock {
    display: none;
  }
}

@media only screen and (max-width: 800px) {

  .row3Col1,
  .row3Col2,
  .row3Col3,
  .row3Txt {
    font-weight: 400;
  }

  .row2Col1,
  .row2Col3 {
    font-weight: 400;
  }
}
</style>
